
import { Component, Vue } from "vue-property-decorator";

interface AracForm {
  aracDegeri: number | null;
  hasarTutari: number | null;
  aracYasi: number | null;
}

interface AracResponse {
  deger_kaybi: number;
  not: string;
}

@Component
export default class AracDegerKaybiHesaplayici extends Vue {
  form: AracForm = { aracDegeri: null, hasarTutari: null, aracYasi: null };
  sonuc: AracResponse | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  get formGecerli(): boolean {
    return (
        this.form.aracDegeri !== null &&
        this.form.aracDegeri >= 0 &&
        this.form.hasarTutari !== null &&
        this.form.hasarTutari >= 0 &&
        this.form.aracYasi !== null &&
        this.form.aracYasi >= 0
    );
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/arac-deger-kaybi",
          {
            arac_degeri: this.form.aracDegeri,
            hasar_tutari: this.form.hasarTutari,
            arac_yasi: this.form.aracYasi,
          }
      );
      const data = response.data || response;
      this.sonuc = data;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
